//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import SfCarouselItem from "./_internal/SfCarouselItem.vue";
import SfArrow from "../../atoms/SfArrow/SfArrow.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfHeading from "../../atoms/SfHeading/SfHeading.vue";
import SfBullets from "../../atoms/SfBullets/SfBullets.vue";
import Glide from "@glidejs/glide";
Vue.component("SfCarouselItem", SfCarouselItem);
export default {
  name: "SfCarousel",
  components: {
    SfArrow,
    SfBullets,
    SfHeading,
    SfButton,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    titleLevel: {
      type: [Number, String],
      default: 2,
    },
    description: {
      type: String,
      default: "",
    },
    button: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    noBullets: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      glide: null,
      defaultSettings: {
        type: "carousel",
        rewind: true,
        perView: 4,
        slidePerPage: true,
        gap: 0,
        breakpoints: {
          1023: {
            perView: 2,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      },
    };
  },
  computed: {
    mergedOptions() {
      let breakpoints = { ...this.defaultSettings.breakpoints };
      if (this.settings.breakpoints) {
        breakpoints = { ...breakpoints, ...this.settings.breakpoints };
      }
      return {
        ...this.defaultSettings,
        ...this.settings,
        breakpoints: breakpoints,
      };
    },
    page() {
      if (this.glide) {
        return Math.ceil(this.glide.index / this.glide.settings.perView);
      }
      return 0;
    },
    carouselSize() {
      const perView = this.glide?.settings ? this.glide.settings.perView : 2;
      return Math.ceil(
        this.$slots?.default?.filter((slot) => slot.tag)?.length / perView
      );
    },
  },
  mounted: function () {
    this.$nextTick(() => {
      if (!this.$slots.default) return;
      const glide = new Glide(this.$refs.glide, this.mergedOptions);
      const size = this.$slots.default.filter((slot) => slot.tag).length;
      if (size <= glide.settings.perView) {
        glide.settings.perView = size;
        glide.settings.rewind = false;
        this.$refs.controls.style.display = "none";
      }
      glide.mount();
      this.applyA11yFix();
      glide.on("run.before", (move) => {
        const { slidePerPage, rewind, type } = this.mergedOptions;
        if (!slidePerPage) return;
        const perView = Math.floor(glide.settings.perView);
        if (!perView > 1) return;
        const { direction } = move;
        let page, newIndex;
        switch (direction) {
          case ">":
          case "<":
            page = Math.ceil(glide.index / perView);
            newIndex =
              page * perView + (direction === ">" ? perView : -perView);
            if (newIndex >= size) {
              if (type === "slider" && !rewind) {
                newIndex = glide.index;
              } else {
                newIndex = 0;
              }
            } else if (newIndex < 0 || newIndex + perView > size) {
              if (type === "slider" && !rewind) {
                newIndex = glide.index;
              } else {
                newIndex = size - perView;
              }
            }
            move.direction = "=";
            move.steps = newIndex;
        }
      });

      this.glide = glide;

      this.glide.on("run.after", () => {
        this.applyA11yFix();
      });
    });
  },
  methods: {
    go(direct) {
      if (!this.glide) return;
      switch (direct) {
        case "prev":
          this.glide.go("<");
          break;
        case "next":
          this.glide.go(">");
          break;
      }
    },
    bulletsGo(event) {
      const size = this.$slots.default.filter((slot) => slot.tag).length;
      const perView = this.glide.settings.perView;
      if (
        perView % 1 === 0 &&
        (Math.floor(size / perView) == event ||
          Math.ceil(size / perView) == event)
      ) {
        this.glide.go(`=${size - perView}`);
      } else {
        this.glide.go(`=${event * perView}`);
      }
    },
    applyA11yFix() {
      this.$nextTick(() => {
        if (!this.glide) return;

        const allSlides = this.$el.querySelectorAll(".glide__slide");
        const clonedSlides = this.$el.querySelectorAll(".glide__slide--clone");
        const activeSlide = this.$el.querySelector(".glide__slide--active");
        const perView = this.glide.settings.perView;

        if (!activeSlide) return;

        // Get all visible slides in the current group
        const activeIndex = [...allSlides].indexOf(activeSlide);
        const visibleSlides = [...allSlides].slice(activeIndex, activeIndex + perView);

        allSlides.forEach((slide) => {
          if (visibleSlides.includes(slide)) {
            // Make visible slides accessible
            slide.removeAttribute("aria-hidden");
            slide.removeAttribute("tabindex");
            slide.querySelectorAll(
              'li:not([tabindex="-1"]) *:not([tabindex="-1"])'
            ).forEach((el) => {
              el.removeAttribute("aria-hidden");
              el.removeAttribute("tabindex");
            });
          } else {
            // Hide out-of-view slides
            slide.setAttribute("aria-hidden", "true");
            slide.setAttribute("tabindex", "-1");
            slide.querySelectorAll(
              'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
            ).forEach((el) => {
              el.setAttribute("aria-hidden", "true");
              el.setAttribute("tabindex", "-1");
            });
          }
        });

        // Always hide cloned slides
        clonedSlides.forEach((slide) => {
          slide.setAttribute("aria-hidden", "true");
          slide.setAttribute("tabindex", "-1");
          slide.querySelectorAll(
            'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
          ).forEach((el) => {
            el.setAttribute("aria-hidden", "true");
            el.setAttribute("tabindex", "-1");
          });
        });
      });
    }
  },
};
